export default "__VITE_ASSET__wX90Lj9z__"